import type { ExceptionFieldId, ExceptionValueFormat } from '../types';

export const PRICE_ADJUSTMENT_MIN = -25;
export const PRICE_ADJUSTMENT_MAX = 25;
export const COMMENTS_MAX_LENGTH = 255;

export const DIALOG_TITLE = 'Apply Eligibility Exception';
export const MANAGE_DIALOG_TITLE = 'Manage Eligibility Exception';
export const SAVE_AND_QUALIFY_LABEL = 'Save and Qualify';
export const CANCEL_LABEL = 'Cancel';
export const APPLY_EXCEPTION_LABEL = 'Apply Exception';
export const MANAGE_EXCEPTION_LABEL = 'Manage Exception';
export const DELETE_AND_QUALIFY_LABEL = 'Delete and Qualify';
export const EXCEPTION_APPLIED_LABEL = 'Exception Applied';

export const COLUMN_HEADERS = {
  field: 'EXCEPTION FIELD',
  guideline: 'GUIDELINE VALUE',
  current: 'CURRENT VALUE',
  adjustment: 'ADJUSTMENT',
  adjusted: 'ADJUSTED VALUE',
  priceAdjustment: 'PRICE ADJUSTMENT',
} as const;

interface ExceptionFieldConfig {
  exceptionFieldId: ExceptionFieldId;
  fieldName: string;
  format: ExceptionValueFormat;
}

export const EXCEPTION_FIELDS: ExceptionFieldConfig[] = [
  { exceptionFieldId: 1, fieldName: 'FICO', format: 'integer' },
  { exceptionFieldId: 2, fieldName: 'LTV', format: 'percent' },
  { exceptionFieldId: 3, fieldName: 'CLTV', format: 'percent' },
  { exceptionFieldId: 4, fieldName: 'HCLTV', format: 'percent' },
  { exceptionFieldId: 5, fieldName: 'Total Loan Amount', format: 'currency' },
  { exceptionFieldId: 6, fieldName: 'Max Line Amount', format: 'currency' },
  { exceptionFieldId: 7, fieldName: 'Max Cash Out', format: 'currency' },
  { exceptionFieldId: 8, fieldName: 'DTI', format: 'percent' },
  { exceptionFieldId: 9, fieldName: 'Liquid Assets', format: 'currency' },
];

export const NA_DISPLAY = 'N/A';

export const OUT_OF_RANGE_MESSAGE =
  'Value for this field is outside the acceptable range.';

// Adjusted value range per field. A null max is unbounded.
export const ADJUSTED_VALUE_RANGES: Record<
  ExceptionFieldId,
  { min: number; max: number | null }
> = {
  1: { min: 350, max: 850 },
  2: { min: 0, max: 200 },
  3: { min: 0, max: 200 },
  4: { min: 0, max: 200 },
  5: { min: 0, max: null },
  6: { min: 0, max: null },
  7: { min: 0, max: null },
  8: { min: 0, max: 100 },
  9: { min: 0, max: null },
};
